import HttpRequest from '../http-request';

const list = async (pageNumber = 0, pageSize = 10) => {
  const response = await HttpRequest.get('/api/public/banner/list.json', {
    pageNumber, pageSize
  });

  return response;
}

export default {
  list
}